import {useRouter} from "next/router";
import Checklist from "./common/Checklist";
import Sidebar from "./common/Sidebar";
import SidebarDropdownSelect from "./common/SidebarDropdownSelect";

import {handleChecklistFilterChange, handleDropdownSelect, handleSearchChange, replaceRouterQueryParamsShallow} from "../helpers/FilterFunctions";
import {SchlafzimmerItems} from "../data/Filter/VermietungFilter.config";
import {LivingAreaItems, PlotSizeItems, VerkaufAusstattungItems, VerkaufLageItems} from "../data/Filter/VerkaufFilter.config";
import {Filter, PropertyTypeQueryKey} from "../data/Filter/Filter.config";
import {useTranslation} from "next-i18next";
import {CustomTFunction, TranslationsKeys} from "../TranslationTypes";

export default function VerkaufSidebar() {
	const router = useRouter();
	const {t} = useTranslation() as unknown as {
		t: CustomTFunction<TranslationsKeys>;
	};
	return (
		<Sidebar
			onSearchChange={(v) => handleSearchChange(v, router)}
			resetFilters={() => {
				const cities = router.query[Filter.City.queryKey];
				const property_types = router.query[PropertyTypeQueryKey];
				const id = router.query.id;
				const queryParams = {
					[Filter.City.queryKey]: cities,
					[PropertyTypeQueryKey]: property_types,
					id
				};
				Object.keys(queryParams).forEach((key) =>
					queryParams[key] === undefined ? delete queryParams[key] : {}
				);
				replaceRouterQueryParamsShallow(router, queryParams);
			}}
		>
			<SidebarDropdownSelect
				dropDowns={[SchlafzimmerItems(router)]}
				onSelectItems={(key, items) =>
					handleDropdownSelect(key, items, router, t)
				}
			/>
			<Checklist
				title={VerkaufAusstattungItems(router).label}
				items={VerkaufAusstattungItems(router).items}
				onChange={(item, checked) =>
					handleChecklistFilterChange(item, checked, router)
				}
			/>
			<Checklist
				title={VerkaufLageItems(router).label}
				items={VerkaufLageItems(router).items}
				onChange={(item, checked) =>
					handleChecklistFilterChange(item, checked, router)
				}
			/>
			{/* <SidebarDropdownSelect
        dropDowns={[DistanceToItems(router, Filter.DistanceToSea)]}
        onSelectItems={(key, items) =>
          handleDropdownSelect(key, items, router, t)
        }
      /> */}
			<SidebarDropdownSelect
				dropDowns={[LivingAreaItems(router), PlotSizeItems(router)]}
				onSelectItems={(key, items) =>
					handleDropdownSelect(key, items, router, t)
				}
			/>
		</Sidebar>
	);
}
